var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 47 35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\n\t.st2{fill:#eaf204;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.2,33.4c-1.1,0-1.2-2.4-3.5-4.9c-2.5-2.7-4.5-2.1-7.1-4.2c-2.7-2.3-3.8-5.8-4-8.2C9.2,9.4,15.9,1.2,24.5,1.2 c8.6,0,15.4,8,14.9,14.9c-0.2,2.8-1.6,6.7-4.7,8.8c-2.7,1.9-4.8,1.1-7.2,3.5C25.3,30.8,25.4,33.4,24.2,33.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker16);
export default __webpack_public_path__ + "static/media/marker16.0cc2f58b61fd36d09ba7b6bf672bff58.svg";
export { ForwardRef as ReactComponent };